import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from 'src/store/customer';

export const useCustomerOldImageGenerationAllowed = () => {
  const currentCustomer = useCurrentCustomer();
  return isCustomerFeatureEnabled(currentCustomer, BE_CUSTOMER_FEATURES.imageGenerationOld);
};
